<script setup lang="ts">
import { useElementalFormStore } from '~~/src/stores/elementalForm'
import { Button, type ButtonVariants } from '@/components/ui/button'
import { type Elemental } from '~~/src/types/elemental'
import { cn } from '~~/src/utils'

const props = defineProps<{
  elemental: Elemental
  iconClass?: HTMLElement['className']
  btnVariant?: ButtonVariants['variant']
}>()

const { open } = useElementalFormStore()

const user = useUser()

const isOwner = computed(() => user.value?.id === props.elemental.user.id)

const handlerClick = () => {
  open('edit', unref(props.elemental), getElementalType(props.elemental.elementalTypeId, props.elemental.isList), true)
}
</script>

<template>
  <Button v-if="isOwner" :variant="btnVariant ?? 'snack-icon'" size="icon" icon="sm" class=" text-soft-black font-700 text-xs" @click="handlerClick">
    <div :class="cn('i-material-symbols:edit-outline w-5 h-5', iconClass)" />
  </Button>
</template>
